import {
  GridColDef,
  GridValidRowModel,
  GridValueFormatterParams,
} from '@mui/x-data-grid-premium';

import { Enum } from '~/data/enums';
import { getFormattedDateString } from '~/utils/helpers/date';

// Column configs utils
export const conditionalGridColDefs = <
  T extends GridValidRowModel = GridValidRowModel,
>(
  condition: boolean,
  column: GridColDef<T>,
): GridColDef<T>[] => {
  return condition ? [column] : [];
};

export const dateCellValueFormatter = (params: GridValueFormatterParams) =>
  getFormattedDateString(params.value, 'L');

// SingleSelect -type column using Enums
export const findDuplicateEnumByCode = (enum2: Enum) => (enum1: Enum) =>
  enum2.code === enum1.code;

export const getSingleSelectColumnEnumValueOptions = (
  enumOptions: Enum[],
  filterOptionCodes?: string[],
  filterDuplicateEnumsByCode?: boolean,
) => {
  const uniqueEnums = filterDuplicateEnumsByCode
    ? enumOptions.filter(
        (enum1, index, array) =>
          array.findIndex(findDuplicateEnumByCode(enum1)) === index,
      )
    : enumOptions;

  const availableEnums = !!filterOptionCodes
    ? uniqueEnums.filter(({ code }) => filterOptionCodes.includes(code))
    : uniqueEnums;

  return availableEnums.map((e) => e.name);
};

// Column Groups utils
export const getFieldNamesFromColumnConfig = <T extends GridValidRowModel>(
  gridColDefs: GridColDef<T>[],
) => gridColDefs.map(({ field }) => ({ field: field }));
